import { RootState } from '../store';

export const getOrganizationDetails = (state: RootState) => state.organization;
export const getOrganizationSubscriptionStatus = (state: RootState) =>
    state.organization.subscriptionStatus;
export const getOrganizationId = (state: RootState) => state.organization.id;
export const getOrganizationName = (state: RootState) => state.organization.name;
export const getOrganizationEmail = (state: RootState) => state.organization.email;
